// Web mock for react-native-webview
import React from 'react';

function flattenStyle(style) {
  if (Array.isArray(style)) {
    return Object.assign({}, ...style.filter(Boolean));
  }
  return style || {};
}

const WebView = ({ source = {}, style, onLoadStart, onLoadEnd, onError, ...props }) => {
  const iframeRef = React.useRef(null);
  const src = source.uri || source.html || '';

  React.useEffect(() => {
    if (onLoadStart) onLoadStart();
  }, [src]);

  const handleLoad = () => {
    if (onLoadEnd) onLoadEnd();
  };

  const handleError = () => {
    if (onError) onError(new Error('WebView failed to load'));
  };

  // If inline HTML is provided, render it in an iframe using srcDoc
  if (source.html) {
    return React.createElement('iframe', {
      ref: iframeRef,
      style: { border: 'none', width: '100%', height: '100%', ...flattenStyle(style) },
      srcDoc: source.html,
      onLoad: handleLoad,
      onError: handleError,
      ...props,
    });
  }

  // Otherwise, render by URL
  return React.createElement('iframe', {
    ref: iframeRef,
    style: { border: 'none', width: '100%', height: '100%', ...flattenStyle(style) },
    src,
    onLoad: handleLoad,
    onError: handleError,
    ...props,
  });
};

export { WebView };
export default WebView;


